<template lang="pug">
v-row
  v-col(cols=12 md=12)(
    v-for="(agreement, idx) in cards"
    :key="agreement.name"
  )
    v-card(
      @click="openModulePreview(agreement, idx)"
      :disabled="agreement.disabled"
    ).sdo-card.stock-item.fill-height
      v-list-item
        v-list-item-title: strong {{ getText(agreement) }}
        v-list-item-action(v-if="agreement.id")
          v-btn(@click.stop="deleteAgreement(agreement.id)" icon color="error")
            v-icon mdi-close
      v-sheet.pa-7(
        :color="agreement.id ? 'success' : 'secondary'"
        dark
      )
        .d-flex
          template(v-if="agreement.prepayment_percent")
            span Процент авансирования
            v-spacer
            span {{ agreement.prepayment_percent }}%
        .d-flex.title
          span {{ getActiveText(agreement) }}
</template>

<script>
import AgreementModal from '@/modules/PaymentSystem/components/AgreementModal.vue';

export default {
  props: {
    cards: { type: Array, default: () => [] },
  },

  methods: {
    getText(agreement) {
      const groupName = !agreement.is_offer ? 'Договор "на бумаге"' : 'Авто-договор';
      return agreement.type === 1 ? 'Договор оферта' : groupName;
    },
    getActiveText({ id, is_offer: isOffer }) {
      return id ? 'Активирован' : `Неактивен${!isOffer ? ' (загрузите договор)' : ''}`;
    },
    deleteAgreement(id) {
      this.$rHandler(
        this.$api.contracts.deleteTypicalContract(id),
        () => { this.$emit('delete'); },
      );
    },
    openModulePreview(moduleItem, idx) {
      this.$modals.show('generic-controller', {
        title: this.getText(moduleItem),
        dialogProps: {
          width: 800,
        },
        component: AgreementModal,
        'component-props': {
          successCallback: (form) => {
            const method = form.id ? 'updateTypicalContract' : 'saveTypicalContract';
            if (form.document) {
              form.document = {
                filename: form.document.file_name,
                original_name: form.document.file_name,
              };
            }
            this.$rHandler(
              this.$api.contracts[method](form, form.id),
              ({ data }) => {
                this.$emit('update', data.data, idx);
                this.$modals.close();
              },
              () => {
                this.$modals.close();
              },
            );
          },
          moduleItem,
          subscribed: !!moduleItem.user_status,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-item {

  &--description {
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}
</style>
